import React, { useContext, useEffect } from 'react';
import { Grid } from '@mui/material';
import { TreeView } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CustomTreeItem from './CustomTreeItem';
import Installation from '../Installations/Installation';
import { InstallationsContext } from 'src/contexts/InstallationsContextProvider';
import { Route, Routes } from 'react-router-dom';
import routes from '../../../Resources/routes.json';
import SalidomoInstallation from '../SalidomoInstallations/Installation';
import Folder from './Folder';
import SodioHomeInstallation from '../SodiohomeInstallations/Installation';

function InstallationTree() {
  const { foldersAndInstallations, fetchAllFoldersAndInstallations } =
    useContext(InstallationsContext);

  const sortedInstallations = [...foldersAndInstallations].sort((a, b) => {
    // Compare the status field of each installation and sort them based on the status.
    //Installations with alarms go first

    if (a.type == 'Folder') {
      return -1;
    }
    let a_status = a.status;
    let b_status = b.status;

    if (a_status > b_status) {
      return -1;
    }
    if (a_status < b_status) {
      return 1;
    }
    return 0;
  });

  useEffect(() => {
    fetchAllFoldersAndInstallations();
  }, []);

  const TreeNode = ({ node, parent_id }) => {
    if (node.type == 'Folder') {
      return (
        node.parentId == parent_id && (
          <CustomTreeItem node={node} parent_id={parent_id}>
            {sortedInstallations.map((subnode) => {
              return (
                subnode != node &&
                subnode.parentId == node.id && (
                  <TreeNode
                    key={subnode.id.toString() + subnode.type}
                    node={subnode}
                    parent_id={node.id}
                  />
                )
              );
            })}
          </CustomTreeItem>
        )
      );
    } else if (node.type == 'Installation') {
      return (
        node.parentId == parent_id && (
          <CustomTreeItem node={node} parent_id={parent_id} />
        )
      );
    } else {
      return null;
    }
  };

  return (
    <Grid container spacing={1} sx={{ marginTop: 0.1 }}>
      <Routes>
        {foldersAndInstallations.map((installation) => {
          if (installation.type == 'Installation') {
            return (
              <Route
                key={installation.id}
                path={routes.installation + installation.id + '/*'}
                element={
                  installation.product == 0 || installation.product == 3 || installation.product == 4 ? (
                    <Installation
                      key={installation.id}
                      current_installation={installation}
                      type="installation"
                    ></Installation>
                  ) : installation.product == 1 ? (
                    <SalidomoInstallation
                      key={installation.id}
                      current_installation={installation}
                      type="installation"
                    ></SalidomoInstallation>
                  ) : (
                    <SodioHomeInstallation
                      key={installation.id}
                      current_installation={installation}
                      type="installation"
                    ></SodioHomeInstallation>
                  )
                }
              />
            );
          } else {
            return (
              <Route
                key={installation.id}
                path={routes.folder + installation.id + '*'}
                element={
                  <Folder
                    key={installation.id + installation.type}
                    current_folder={installation}
                  ></Folder>
                }
              />
            );
          }
        })}
      </Routes>
      <Grid item xs={12} md={12}>
        <TreeView
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          defaultExpanded={['1Folder']}
        >
          {foldersAndInstallations.map((node, index) => {
            return (
              <TreeNode
                key={node.id.toString() + node.type}
                node={node}
                parent_id={'0'}
              />
            );
          })}
        </TreeView>
      </Grid>
    </Grid>
  );
}

export default InstallationTree;
